import React from 'react';
import { PriceRangeCountRow } from '../../types';
import { useFilters } from '../../cube/filters';
import { D3BarChart } from './D3BarChart';

interface PriceRangeBarProps {
  data: PriceRangeCountRow[];
}

export const PriceRangeBar: React.FC<PriceRangeBarProps> = ({ data }) => {
  const { filters, set } = useFilters();
  const selected = filters.priceRange || [];
  
  const clustered = React.useMemo(() => {
    const grouped = new Map<number, number>();
    (data || []).forEach((d) => {
      const bucket = d.price_m2_bucket;
      const key = bucket >= 100 ? 100 : bucket;
      grouped.set(key, (grouped.get(key) || 0) + (Number(d.count) || 0));
    });
    return Array.from(grouped.entries()).map(([key, value]) => ({ key, value }));
  }, [data]);

  return (
    <D3BarChart
      data={clustered}
      title="Imóveis por Faixa de Preço"
      xLabel="Faixa de Preço (R$/m²)"
      yLabel="Número de Imóveis"
      selectedKeys={selected}
      onBarClick={(key) => {
        const k = Number(key);
        const active = selected.includes(k);
        const next = active ? selected.filter((n) => n !== k) : [...selected, k];
        set({ priceRange: next.length ? next : undefined });
      }}
      formatXTick={(k) => Number(k) >= 100 ? '100+' : String(Number(k) + 10)}
      formatYTick={(n) => String(Math.round(n))}
    />
  );
};

